import FourDotLoader from './FourDotLoader'

export default FourDotLoader